import React from 'react';
import styled from 'styled-components';
import { Left, BaseStyles, Wrapper, Comment } from './styled';
import { Suitcase } from '../Icons';
const JobTitle = styled.span `
  font-size: ${(props) => props.theme.fontXXSmall};
  font-weight: ${(props) => props.theme.bold};
`;
const LegalPersonName = styled.span `
  font-size: ${(props) => props.theme.fontXXSmall};
`;
const TaxNumber = styled.span `
  font-size: ${(props) => props.theme.fontXXSmall};
`;
export const Legal = ({ givenName, surname, email, rightColumn, translations, jobTitle, legalPerson, currentUser, comment, }) => (React.createElement(Wrapper, null,
    React.createElement(BaseStyles, { className: "Legal", key: email },
        React.createElement(Left, { className: "left-section" },
            React.createElement("span", { className: "receiver-type" },
                React.createElement(Suitcase, { className: "icon" }),
                translations && translations.legalPerson),
            React.createElement("span", { className: "receiver-name" },
                givenName,
                " ",
                surname,
                " ",
                currentUser ? translations.you : ''),
            React.createElement("span", { className: "delivery-box" }, email),
            React.createElement(JobTitle, null, jobTitle),
            React.createElement(LegalPersonName, null, legalPerson && legalPerson.name),
            React.createElement(TaxNumber, null,
                translations && translations.taxNumber,
                ' ',
                legalPerson && legalPerson.country + legalPerson.taxNumber)),
        rightColumn),
    comment && (React.createElement(Comment, null,
        React.createElement("span", { className: "comment-title" }, translations.comment),
        React.createElement("span", { className: "comment" }, comment)))));
Legal.defaultProps = {
    legalPerson: {
        name: '',
        taxNumber: '',
    },
};
export default Legal;
